import { Component, ElementRef, ViewChild, AfterViewInit, Input, ChangeDetectorRef, HostListener } from '@angular/core';

@Component({
    template: '<div>This component requires extending</div>',
})
export class SliderComponent implements AfterViewInit {
    private _init: boolean = false;
    private _slidesElems: Array<HTMLElement>;
    private _listWidth!: number;
    private _isAnimating: boolean = false;

    @Input() public loading: boolean = false;
    @Input() public currentSlide: number = 0;
    @Input() public animationTimeout: number = 300;
    @Input() public loop: boolean = true;
    @Input() public arrows: boolean = true;
    @Input() public dots: boolean = true;
    @Input() public iconNext: string = 'next';
    @Input() public iconPrev: string = 'prev';
    @Input() public stopPropagation: boolean = true;
    @Input() public inverted: boolean = false;

    @ViewChild('contentElem') public contentElem: ElementRef;
    @ViewChild('listElem') public listElem: ElementRef;

    @HostListener('window:resize', ['$event']) public onResize($event: Event): void {
        setTimeout(() => {
            this._setup();
        }, 200);
    }

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngAfterViewInit(): void {
        this._init = true;

        setTimeout(() => {
            this._setup();
        }, 0);
    }

    private _stopPropagation($event: Event): void {
        if ($event && this._stopPropagation) {
            $event.stopPropagation();
        }
    }

    public handleContentChange($event: Array<HTMLElement>): void {
        this._slidesElems = [...$event];

        this._setup();
    }

    private async _lock(): Promise<boolean> {
        this._isAnimating = true;

        return new Promise(resolve => {
            setTimeout(() => {
                this._isAnimating = false;
                resolve(true);
                this._calculateListWidth();
            }, this.animationTimeout);
        });
    }

    private _setup(): void {
        if (!this._init) return;
        const tempAnimTimeout = this.animationTimeout;

        this._isAnimating = false;
        this.animationTimeout = null;

        this._calculateListWidth();

        this._setVisibleSlide(this.currentSlide)
            .then(() => {
                this.animationTimeout = tempAnimTimeout;
            });
    }

    private async _setVisibleSlide(slideNo: number = 0): Promise<boolean> {
        if (!this._init || !this._slidesElems || !this._slidesElems.length || this._isAnimating || slideNo === this.currentSlide || this.isLoading) return;

        this.currentSlide = slideNo;

        return new Promise(resolve => {
            this._lock();

            setTimeout(() => {
                this._calculateListWidth();
                resolve(true);
                this._calculateListWidth();
            }, this.animationTimeout);
        });
    }

    private _calculateListWidth(): number {
        setTimeout(() => {
            this._listWidth = this.holderWidth * this._slidesElems?.length;
            this.changeDetectorRef.detectChanges();
        }, 0);

        return this._listWidth = this.holderWidth * this._slidesElems?.length;
    }

    public handleNextClick($event: Event): void {
        if (this._isAnimating) return;
        this._stopPropagation($event);
        let nextSlideIndex: number = this.currentSlide + 1;

        if (nextSlideIndex > this.maxIndex) {
            if (!this.loop) {
                return;
            }

            nextSlideIndex = 0;
        }

        this._setVisibleSlide(nextSlideIndex);
    }

    public handlePrevClick($event: Event): void {
        if (this._isAnimating) return;
        this._stopPropagation($event);
        let prevSlideIndex: number = this.currentSlide - 1;

        if (prevSlideIndex < 0) {
            if (!this.loop) {
                return;
            }

            prevSlideIndex = this.maxIndex;
        }

        this._setVisibleSlide(prevSlideIndex);
    }

    public handleDotClick($event: { event: Event; index: number; }): void {
        this._stopPropagation($event.event);
        this._setVisibleSlide($event.index);
    }

    public get holderWidth(): number {
        return this.contentElem && this.contentElem.nativeElement && this.contentElem.nativeElement.clientWidth || 0;
    }


    public get listTotalWidth(): number {
        return this._listWidth;
    }

    public get listOffset(): number {
        return -1 * this.currentSlide * this.holderWidth;
    }

    public get transitionDuration(): number {
        return this.animationTimeout;
    }

    public get maxIndex(): number {
        return this._slidesElems && this._slidesElems.length - 1 || 0;
    }

    public get canGoBack(): boolean {
        return this.loop ? true : this.currentSlide > 0;
    }

    public get canGoNext(): boolean {
        return this.loop ? true : this.currentSlide < this.maxIndex;
    }

    public get showArrows(): boolean {
        if (this.isLoading) return false;

        return !this.arrows ? false : this.maxIndex > 0;
    }

    public get showDots(): boolean {
        return this.dots;
    }

    public get canUseDots(): boolean {
        return !this.isLoading && this.maxIndex > 0;
    }

    public get activeIndex(): number {
        return this.currentSlide;
    }

    public get isLoading(): boolean {
        return this.loading;
    }

    public get currentCount(): number {
        return (this.activeIndex || 0) + 1;
    }

    public get totalCount(): number {
        return this._slidesElems?.length || 0;
    }

    public get isAnimating(): boolean {
        return this._isAnimating;
    }
}
